import type { AppData } from "./types";

export const liveCallStatuses = new Set([
  "connected",
  "in_progress",
  "ringing",
  "queued",
  "forwarding",
]);

export function isLiveCallStatus(status: string) {
  return liveCallStatuses.has(status);
}

export function activeCalls(data: AppData) {
  return data.conversations
    .filter((call) => isLiveCallStatus(call.status))
    .sort((a, b) => b.startedAt.localeCompare(a.startedAt));
}
